<template>
  <div>
  </div>
</template>

<script>
import "confetti-js";
export default {
  created() {
    let canvas = document.getElementById("confetti");
    canvas.style.zIndex = 10;
    let confittJson = {"target":"confetti","max":"90","size":"1","animate":true,"props":["circle","square","triangle","line",{"type":"svg","src":"site/hat.svg","size":25,"weight":0.2}],"colors":[[165,104,246],[230,61,135],[0,199,228],[253,214,126]],"clock":"25","rotate":false }
    this.confetti = new ConfettiGenerator(confittJson);
    this.confetti.render();
  },
  destroyed() {
    let canvas = document.getElementById("confetti");
    canvas.style.zIndex = -1;
    this.confetti.clear();
  }
}
</script>

<style>

</style>
